import { ConsentState } from './types';

export const COOKIE_CONSENT_KEY = 'USE_COOKIE_CONSENT_STATE';
export const DEFAULT_CONSENT: ConsentState = { necessary: true };
